import { classNameMerger } from '@breetometer/utils';
import { WalletBalance } from 'BreetComponents';
import { useCryptoSettings, useUserCurrencyProps } from 'BreetHooks';
import { selectUser, useAppSelector } from 'BreetRedux';

export const AllWalletBalances = () => {
	const userData = useAppSelector(selectUser);

	const { currentReceiveCurrency } = useCryptoSettings();

	const currencyCode = useUserCurrencyProps();
	const userCurrencyCode = currencyCode?.code ?? 'NGN';

	const otherCode = userCurrencyCode === 'NGN' ? 'GHS' : 'NGN';

	const isApiAccess = userData.data?.data?.apiAccess;
	return (
		<>
			{(userCurrencyCode === 'NGN' || userCurrencyCode === 'GHS') && (
				<div className={classNameMerger('apphome_hero scrollbar')}>
					<WalletBalance
						fiat={userCurrencyCode}
						isSettlementWallet={currentReceiveCurrency?.toUpperCase() === userCurrencyCode}
					/>
					<WalletBalance
						fiat='USD'
						isSettlementWallet={currentReceiveCurrency?.toUpperCase() === 'USD'}
					/>
					{isApiAccess && (
						<WalletBalance
							fiat={otherCode}
							isSettlementWallet={currentReceiveCurrency?.toUpperCase() === otherCode}
							isApiAccess
						/>
					)}
				</div>
			)}
		</>
	);
};
